import {
  LOAD_ROLES,
  LOAD_TENDER_TYPES,
  LOAD_TENDER_VALIDATORS,
  ROLES_LOADED,
  SYNCING,
  SYNC_FAILED,
  TENDER_TYPES_LOADED,
  TENDER_VALIDATORS_LOAD_ERROR,
  TENDER_VALIDATORS_LOADED,
  TOUCH_POINT_GROUPS_ERROR,
  TOUCH_POINT_GROUPS_LOADED,
  LOAD_TOUCH_POINT_GROUPS,
} from './actionTypes';
import {
  ISetMetaDatasAction,
  IMetaDataState,
  IFailedSyncAction,
  ISetTenderAction,
  IAxiosErrorSyncAction,
  ISetTouchPointAction,
} from './types';

export const initialState = {
  error: null,
  loadTenderTypes: false,
  loadedRoles: false,
  roles: [],
  rolesLoaded: false,
  syncing: false,
  syncingRoles:false,
  tenderTypes: [],
  tenderTypesLoaded: false,
  tenderValidators: [],
  tenderValidatorsLoaded: false,
  tenderValidatorsSyncing: false,
  tenderValidatorsError: null,
  touchPointGroupsLoaded: false,
  touchPointGroupsSyncing: false,
  touchPointGroupsError: null,
  touchPointGroups: [],
};

export const reducer = (
  state: IMetaDataState = initialState,
  action: { type: string; payload?: any }
): IMetaDataState => {
  switch (action.type) {
    case LOAD_ROLES:
      return { ...state, error: null, roles: [], syncingRoles: true };
    case ROLES_LOADED:
      return {
        ...state,
        error: null,
        rolesLoaded: true,
        roles: (action as ISetMetaDatasAction).payload,
        syncingRoles: false,
      };
    case LOAD_TENDER_TYPES:
      return { ...state, error: null, tenderTypes: [], syncing: true };
    case TENDER_TYPES_LOADED:
      return {
        ...state,
        error: null,
        tenderTypes: (action as ISetTenderAction).payload,
        syncing: true,
      };
    case SYNCING:
      return { ...state, syncing: true };
    case SYNC_FAILED:
      return { ...state, error: (action as IFailedSyncAction).payload, syncing: false };
    case LOAD_TENDER_VALIDATORS:
      return {
        ...state,
        tenderValidatorsError: null,
        tenderValidatorsLoaded: false,
        tenderValidatorsSyncing: true,
        tenderValidators: [],
      };
    case TENDER_VALIDATORS_LOADED:
      return {
        ...state,
        tenderValidatorsError: null,
        tenderValidatorsLoaded: true,
        tenderValidatorsSyncing: false,
        tenderValidators: (action as ISetTenderAction).payload,
      };
    case TENDER_VALIDATORS_LOAD_ERROR:
      return {
        ...state,
        tenderValidatorsError: (action as IAxiosErrorSyncAction).payload,
        tenderValidatorsLoaded: true,
        tenderValidatorsSyncing: false,
        tenderValidators: [],
      };
    case LOAD_TOUCH_POINT_GROUPS:
      return {
        ...state,
        touchPointGroupsLoaded: false,
        touchPointGroupsSyncing: true,
        touchPointGroups: [],
      };
    case TOUCH_POINT_GROUPS_LOADED:
      return {
        ...state,
        touchPointGroupsLoaded: true,
        touchPointGroupsSyncing: false,
        touchPointGroups: (action as ISetTouchPointAction).payload,
      };
    case TOUCH_POINT_GROUPS_ERROR:
      return {
        ...state,
        touchPointGroupsError: (action as IAxiosErrorSyncAction).payload,
        touchPointGroupsLoaded: false,
        touchPointGroupsSyncing: false,
        touchPointGroups: [],
      };

    default:
      return state;
  }
};
